export const categories = [
  {
    category: "Director",
    label: "Director",
  },
  {
    category: "Producer",
    label: "Producer",
  },
  {
    category: "Scriptwriting",
    label: "Scriptwriter",
  },
  {
    category: "Research",
    label: "Researcher",
  },
  {
    category: "Props",
    label: "Propser",
  },
  {
    category: "Art",
    label: "Art Person",
  },
  {
    category: "Art Lead",
    label: "Art Lead",
  },
  {
    category: "Post",
    label: "Post Person",
  },
  {
    category: "Video",
    label: "Operator",
  },
  {
    category: "Costumes",
    label: "Costumer",
  },
  {
    category: "Thumb",
    label: "Thumbnailer",
  },
  {
    category: "Make Up",
    label: "Make Up Artist",
  },
  {
    category: "Filming Coordination",
    label: "Coordinator",
  },
];

export const events = [
  {
    title: "Topic Presentation",
    categories: [
      "Owner",
      "Director",
      "Scriptwriting",
      "Research",
      "Props",
      "Art",
      "Post",
      "Video",
      "Costumes",
      "Thumb",
      "Make Up",
    ],
  },
  { title: "Pitch 1", categories: ["Director", "Scriptwriting"] },
  {
    title: "Pitch 2",
    categories: ["Director", "Scriptwriting"],
  },
  { title: "Pitch 3", categories: ["Owner", "Director", "Scriptwriting"] },
  {
    title: "Script Review",
    categories: [
      "Owner",
      "Director",
      "Scriptwriting",
      "Props",
      "Art",
      "Video",
      "Filming Coordination",
      "Costumes",
      "Make Up",
    ],
  },
  {
    title: "Post - Production Meeting (PPM)",
    categories: [
      "Owner",
      "Director",
      "Scriptwriting",
      "Props",
      "Art",
      "Post",
      "Video",
      "Filming Coordination",
      "Costumes",
      "Thumb",
      "Make Up",
    ],
  },
  {
    title: "Shotlist",
    categories: ["Owner", "Director", "Props", "Art", "Post", "Video", "Thumb"],
  },
];

export const facebookRooms = ["Havana", "New York", "London", "Miami"];

export const youtubeRooms = [
  "Japoniška",
  "Suomiška",
  "Sauna",
  "Ukrainietiška",
  "Garinė",
  "Turkiška",
];
